module.exports = __webpack_public_path__ + "img/p7.f5749f9f.png";